import styled from 'styled-components';

// ${({ theme }) => theme.fontSize.s};

const Paragraph = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.2em;
  color: ${({ theme }) => theme.black};
`;

export default Paragraph;
